import { useApi } from 'hooks/api';
import { DeclarationStatusType } from 'hooks/declarationData/types';


export interface BookingCompanyModel {
    companyId: string;
    name: string;
    declarationsTotal: number;
    declarationsAccepted: number;
    declarationsDenied: number;
    expendature: number;
    q1: number;
    q2: number;
    q3: number;
    q4: number;
    employeeBookings: EmployeeBookingModel[]
}

export interface EmployeeBookingModel {
    userName: string;
    userId: string;
    bookings: BookingModel[];
    declarationsTotal: number;
    declarationsAccepted: number;
    declarationsDenied: number;
    expendature: number;
    submittedDate: Date;
}

export interface BookingModel {
    id: string;
    description: string;
    startDate: Date;
    endDate: Date;
    codeType: BookingCode;
    declarationStatus?: DeclarationStatusType;
    status: string;
    submittedAmount?: number;
    paidOutAmount?: number;
    periodType: BookingPeriod;
    submittedDate: Date;
}

export interface BookingUserDetailModel {
    userFullName: string;
    bookings: BookingModel[];
    balance: number;
    declarationsAmount: number;
    subscriptionsAmount: number;
    employerContribution: number;
}

export enum BookingCode {
    EmployerContribution = 0,
    Registercosts = 1,
    Subscription = 2,
    Declaration = 3
}

export enum BookingPeriod {
    FourWeeks = 0,
    Monthly = 1
}

export interface BfaCompanyInvoicesModel {
    name: string;
    totalAmount: number;
    invoices: BfaInvoiceModel[];
}

export interface BfaInvoiceModel {
    bookingId: string;
    employeeId: string;
    userName: string;
    description: string;
    grossAmount: number;
    startDate: Date;
}

export interface CreateCustomInvoiceModel {
    employerId: string;
    employeeId: string;
    grossAmount: number;
    description: string;
}

export interface InvoiceForBfaModel {
    bookingId: string;

}


export const useBookings = () => {
    const { callApi } = useApi();

    const getBookings = async () => {
        const response = await callApi.current<BookingModel[]>('/booking/v1');
        return response;

    };

    const getBookingsOfUser = async (userId: string) => {
        const response = await callApi.current<BookingUserDetailModel>(`/booking/v1/${userId}`);
        return response;

    };

    const getBookingsCompanies = async () => {
        const response = await callApi.current<BookingCompanyModel[]>('/booking/v1/companies');
        return response;
    };

    const getEmployerInvoices = async () => {
        const response = await callApi.current<BfaCompanyInvoicesModel[]>('/booking/v1/invoices');
        return response;
    };

    const createCustomInvoice = async (invoice: CreateCustomInvoiceModel) => {
        const response = await callApi.current('/booking/v1/createCustom', { method: 'POST', body: JSON.stringify(invoice) });
        return response;
    };

    const sendInvoicesToBfa = async (invoices: InvoiceForBfaModel[]) => {
        const response = await callApi.current('/booking/v1/sendToBfa', { method: 'PUT', body: JSON.stringify(invoices) });
        return response;
    };

    return { getBookings, getBookingsOfUser, getBookingsCompanies, getEmployerInvoices, createCustomInvoice, sendInvoicesToBfa };
};